import {Config} from "../../config/config";
import {ActivityAction} from '../../activities/activity';

export enum ProductOrigin {
  TEN_WEB = '10web',
  WORDPRESS = 'wp.org',
  UPLOAD = 'upload'
}

export enum ProductType {
  PLUGIN = 'plugin',
  ADD_ON = 'addon',
  THEME = 'theme'
}

export class Product {

  public uid: number|string;
  public productId: number;
  public slug: string;
  public type: string;
  public origin: string;
  public service: string;
  public title: string;
  public description: string;
  public logo: string;
  public author: string;
  public authorUrl: string;
  public version: string;
  public currentVersion: any;
  public hasAddons: boolean;
  public downloadLink: string;
  public downloads: number;
  public demoLink: string;

  public installed: boolean;
  public paidVersionInstalled: boolean;
  public hasPaidVersion: boolean;
  public hasPaidVersionPremium: boolean;
  public availableForHosting: boolean;
  public paidVersionAvailable: boolean;
  public parentId: number;
  public active: boolean;
  public updateAvailable: boolean;
  public isNetwork: boolean;
  public selected: boolean;
  public childrenToggled: boolean;
  public popularRank: number;
  public requiredWordpressVersion: string;
  public activeInstalls: string;
  public lastUpdated: Date;
  public rating: number;
  public requires: any;
  public tenWebProduct: boolean;
  public networkActive: boolean;

  public file: any;

  public static createUploadProduct(file: File, type: string): Product {
    const plugin: Product = new Product();
    plugin.uid = 'upload';
    plugin.slug = 'upload';
    plugin.type = type;
    plugin.origin = ProductOrigin.UPLOAD;
    plugin.title = 'upload';
    plugin.file = file;

    return plugin;
  }

  public static isService(slug: string): boolean {
    return Config.servicePluginSlugs.includes(slug);
  }

  public canApplyAction(actionType: string): boolean {
    switch (actionType) {
      case ActivityAction.INSTALL:
        return !this.installed || (!this.paidVersionInstalled && this.hasPaidVersion);

      case ActivityAction.INSTALL_ACTIVATE:
        return !this.installed || (!this.paidVersionInstalled && this.hasPaidVersion);

      case ActivityAction.INSTALL_ACTIVATE_UPLOAD:
        return !this.installed || (!this.paidVersionInstalled && this.hasPaidVersion);

      case ActivityAction.UPDATE:
        return this.updateAvailable;

      case ActivityAction.DEACTIVATE_DELETE:
        return this.installed;

      case ActivityAction.ACTIVATE:
        return this.installed && !this.active;

      case ActivityAction.DEACTIVATE:
        return this.installed && this.active;
    }

    return false;
  }

}
